import React from 'react';
import { bgColorClassname } from '@/utils';
import type { ImageAsset } from '@sanity/types';
import { Image, MaskedImage } from '@/components';

interface ImageWithMask {
  _key: string;
  alt?: string;
  image: {
    asset: ImageAsset;
  };
  mask: string;
}

interface InsetImageProps {
  backgroundColor?: {
    label: string;
    value: string;
  };
  reverseImageLayout: boolean;
  images: ImageWithMask[];
}

function getImageProps(index: number): string {
  switch (index) {
    case 1:
      return 'group-[.right-side]:self-start group-[.left-side]:self-end group-[.left-side]:mb-[37px] md:group-[.left-side]:mb-0 max-w-[150px] sm:max-w-[200px] md:max-w-36 min-[950px]:max-w-44 lg:max-w-[200px] md:group-[.left-side]:self-end';
    case 2:
      return 'group-[.left-side]:self-start max-w-[150px] sm:max-w-[200px] md:max-w-36 min-[950px]:max-w-44 lg:max-w-[200px] mt-0 ml-[-10%] md:ml-0 md:mt-[-25%] group-[.right-side]:self-end';
    case 3:
      return 'group-[.right-side]:self-start group-[.left-side]:self-end max-w-[150px] sm:max-w-[200px] md:max-w-36 min-[950px]:max-w-44 lg:max-w-[200px] mt-0 ml-[-10%] md:ml-0 md:mt-[-20%] md:group-[.left-side]:self-end md:group-[.left-side]:mr-9 md:group-[.right-side]:ml-9';
    default:
      return '';
  }
}

const InsetImage: React.FC<InsetImageProps> = ({ backgroundColor, reverseImageLayout, images }) => {
  const layout = reverseImageLayout ? 'left-side' : 'right-side';
  const singleImage = images.length === 1;

  return (
    <div
      className={`flex h-full w-full items-center ${backgroundColor ? bgColorClassname(backgroundColor) : ''}`}
    >
      <div
        className={`mx-auto flex h-full max-h-[280px] w-full px-5 py-8 sm:max-h-[380px] md:max-w-[340px] md:p-[50px] min-[950px]:max-w-[395px] lg:max-w-[460px] ${images.length === 2 ? 'min-h-[340px] sm:min-h-[400px] md:max-h-[330px] md:min-h-[330px] min-[950px]:max-h-[375px] min-[950px]:min-h-[375px] lg:max-h-[410px] lg:min-h-[410px]' : `${singleImage ? '' : 'min-h-[280px] sm:min-h-[380px] md:min-h-[430px] min-[950px]:min-h-[490px] lg:min-h-[535px]'} `}`}
      >
        <div
          className={`group flex justify-center md:justify-between ${singleImage ? 'items-center self-center' : ''} w-full md:flex-col ${layout} ${layout === 'left-side' ? '' : ''}`}
        >
          {images &&
            images.map((image, index) => (
              <div
                key={image._key}
                className={`image-${index + 1} ${singleImage ? 'max-w-[150px] sm:max-w-[220px]' : getImageProps(index + 1)}  `}
              >
                {image.mask && image.mask != 'no-mask' ? (
                  <MaskedImage
                    image={image?.image}
                    mask={image.mask}
                    className='aspect-square w-full'
                    showStroke={true}
                    alt={image?.alt}
                    width={500}
                  />
                ) : (
                  <Image
                    image={image?.image}
                    alt={image?.alt}
                    className='max-full'
                    width={500}
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default InsetImage;
